module.exports = __webpack_public_path__ + "media/images/logo_white-626254b5cc39c8241bc37e944cf55ef9.png";